export default "__VITE_ASSET__BZ7viGHL__"